const productKeys = {
  birth: {
    fr: { title: 'Traduction acte de naissance', short: 'Acte de naissance — traduction assermentée & certifiée' },
    ar: { title: 'ترجمة شهادة الميلاد', short: 'شهادة الميلاد — ترجمة معتمدة ومصدقة' },
    en: { title: 'Birth certificate translation', short: 'Birth certificate — sworn & certified translation' },
  },
  marriage: {
    fr: { title: 'Traduction acte de mariage', short: 'Acte de mariage — traduction assermentée & certifiée' },
    ar: { title: 'ترجمة عقد الزواج', short: 'عقد الزواج — ترجمة معتمدة ومصدقة' },
    en: { title: 'Marriage certificate translation', short: 'Marriage certificate — sworn & certified translation' },
  },
  death: {
    fr: { title: 'Traduction acte de décès', short: 'Certificat de décès — traduction assermentée' },
    ar: { title: 'ترجمة شهادة الوفاة', short: 'شهادة الوفاة — ترجمة معتمدة' },
    en: { title: 'Death certificate translation', short: 'Death certificate — sworn translation' },
  },
  passport: {
    fr: { title: 'Traduction passeport', short: 'Passeport — traduction assermentée' },
    ar: { title: 'ترجمة جواز السفر', short: 'جواز السفر — ترجمة معتمدة' },
    en: { title: 'Passport translation', short: 'Passport — sworn translation' },
  },
  idcard: {
    fr: { title: 'Traduction carte d\'identité', short: 'Carte d\'identité — traduction assermentée & certifiée' },
    ar: { title: 'ترجمة بطاقة الهوية', short: 'بطاقة الهوية — ترجمة معتمدة ومصدقة' },
    en: { title: 'ID card translation', short: 'Identity card — sworn & certified translation' },
  },
  naturalization: {
    fr: { title: 'Acte de naturalisation', short: 'Naturalisation / nationalité — traduction assermentée' },
    ar: { title: 'شهادة التجنس', short: 'التجنس / الجنسية — ترجمة معتمدة' },
    en: { title: 'Naturalization certificate', short: 'Naturalization / nationality — sworn translation' },
  },
  celibacy: {
    fr: { title: 'Certificat de célibat', short: 'Certificat de célibat — traduction assermentée & certifiée' },
    ar: { title: 'شهادة العزوبية', short: 'شهادة العزوبية — ترجمة معتمدة ومصدقة' },
    en: { title: 'Celibacy certificate', short: 'Celibacy certificate — sworn & certified translation' },
  },
  residenceCard: {
    fr: { title: 'Carte de séjour', short: 'Traduction assermentée carte de séjour' },
    ar: { title: 'بطاقة الإقامة', short: 'ترجمة معتمدة لبطاقة الإقامة' },
    en: { title: 'Residence permit', short: 'Sworn residence permit translation' },
  },
  familyBook: {
    fr: { title: 'Livret de famille', short: 'Livret de famille — traduction assermentée & certifiée' },
    ar: { title: 'دفتر العائلة', short: 'دفتر العائلة — ترجمة معتمدة ومصدقة' },
    en: { title: 'Family record book', short: 'Family record book — sworn & certified translation' },
  },
  pacs: {
    fr: { title: 'Attestation PACS', short: 'Pacte civil de solidarité — traduction certifiée' },
    ar: { title: 'شهادة الشراكة المدنية', short: 'عقد الشراكة المدنية — ترجمة مصدقة' },
    en: { title: 'PACS certificate', short: 'Civil partnership — certified translation' },
  },
  divorceCert: {
    fr: { title: 'Attestation de divorce', short: 'Certificat de divorce — traduction assermentée' },
    ar: { title: 'شهادة الطلاق', short: 'شهادة الطلاق — ترجمة معتمدة' },
    en: { title: 'Divorce certificate', short: 'Divorce certificate — sworn translation' },
  },
  nameChange: {
    fr: { title: 'Changement de nom', short: 'Certificat de changement de nom — traduction assermentée' },
    ar: { title: 'تغيير الاسم', short: 'شهادة تغيير الاسم — ترجمة معتمدة' },
    en: { title: 'Name change certificate', short: 'Name change certificate — sworn translation' },
  },
  baptism: {
    fr: { title: 'Acte de baptême', short: 'Acte de baptême — traduction assermentée & certifiée' },
    ar: { title: 'شهادة المعمودية', short: 'شهادة المعمودية — ترجمة معتمدة ومصدقة' },
    en: { title: 'Baptism certificate', short: 'Baptism certificate — sworn & certified translation' },
  },
  recognition: {
    fr: { title: 'Acte de reconnaissance', short: 'Acte de reconnaissance — traduction assermentée' },
    ar: { title: 'عقد الإقرار', short: 'عقد الإقرار — ترجمة معتمدة' },
    en: { title: 'Recognition of paternity', short: 'Recognition act — sworn translation' },
  },
  domicile: {
    fr: { title: 'Justificatif de domicile', short: 'Justificatif de domicile — traduction assermentée' },
    ar: { title: 'إثبات السكن', short: 'إثبات السكن — ترجمة معتمدة' },
    en: { title: 'Proof of address', short: 'Proof of address — sworn translation' },
  },
  diploma: {
    fr: { title: 'Traduction diplôme', short: 'Diplôme universitaire — traduction assermentée' },
    ar: { title: 'ترجمة الشهادة', short: 'الشهادة الجامعية — ترجمة معتمدة' },
    en: { title: 'Diploma translation', short: 'University diploma — sworn translation' },
  },
  transcript: {
    fr: { title: 'Traduction relevé de notes', short: 'Relevé de notes BAC — traduction assermentée en 24h possible' },
    ar: { title: 'ترجمة كشف النقاط', short: 'كشف نقاط البكالوريا — ترجمة معتمدة خلال 24 ساعة' },
    en: { title: 'Transcript translation', short: 'High school transcript — sworn translation, 24h express available' },
  },
  transcriptUni: {
    fr: { title: 'Relevé de notes université', short: 'Relevé de notes universitaire — traduction assermentée' },
    ar: { title: 'كشف نقاط الجامعة', short: 'كشف نقاط جامعي — ترجمة معتمدة' },
    en: { title: 'University transcript', short: 'University transcript — sworn translation' },
  },
  reportCard: {
    fr: { title: 'Bulletin de notes', short: 'Bulletin scolaire avec appréciations — traduction assermentée' },
    ar: { title: 'بطاقة العلامات', short: 'بطاقة مدرسية مع الملاحظات — ترجمة معتمدة' },
    en: { title: 'School report card', short: 'School report with comments — sworn translation' },
  },
  studyAttestation: {
    fr: { title: 'Attestation de diplôme', short: 'Attestation universitaire — traduction assermentée' },
    ar: { title: 'شهادة الدراسة', short: 'شهادة جامعية — ترجمة معتمدة' },
    en: { title: 'Degree attestation', short: 'University attestation — sworn translation' },
  },
  enrollment: {
    fr: { title: 'Attestation d\'inscription', short: 'Attestation d\'inscription universitaire — traduction assermentée' },
    ar: { title: 'شهادة التسجيل', short: 'شهادة تسجيل جامعي — ترجمة معتمدة' },
    en: { title: 'Enrollment certificate', short: 'University enrollment — sworn translation' },
  },
  schoolAttestation: {
    fr: { title: 'Attestation de scolarité', short: 'Attestation de scolarité — traduction assermentée' },
    ar: { title: 'شهادة الالتحاق', short: 'شهادة الالتحاق بالمدرسة — ترجمة معتمدة' },
    en: { title: 'School attendance certificate', short: 'School attendance — sworn translation' },
  },
  internship: {
    fr: { title: 'Attestation de stage', short: 'Attestation de stage — traduction assermentée' },
    ar: { title: 'شهادة التدريب', short: 'شهادة التدريب — ترجمة معتمدة' },
    en: { title: 'Internship certificate', short: 'Internship certificate — sworn translation' },
  },
  recommendation: {
    fr: { title: 'Lettre de recommandation', short: 'Lettre de recommandation — traduction assermentée' },
    ar: { title: 'رسالة توصية', short: 'رسالة توصية — ترجمة معتمدة' },
    en: { title: 'Recommendation letter', short: 'Recommendation letter — sworn translation' },
  },
  diplomaSupplement: {
    fr: { title: 'Supplément au diplôme', short: 'Supplément au diplôme — traduction assermentée' },
    ar: { title: 'ملحق الشهادة', short: 'ملحق الشهادة — ترجمة معتمدة' },
    en: { title: 'Diploma supplement', short: 'Diploma supplement — sworn translation' },
  },
  criminal: {
    fr: { title: 'Extrait de casier judiciaire', short: 'Traduction extrait de casier judiciaire assermentée' },
    ar: { title: 'السجل العدلي', short: 'ترجمة معتمدة للسجل العدلي' },
    en: { title: 'Criminal record extract', short: 'Sworn criminal record translation' },
  },
  driving: {
    fr: { title: 'Traduction permis de conduire', short: 'Permis de conduire — traduction assermentée (24h possible)' },
    ar: { title: 'ترجمة رخصة السياقة', short: 'رخصة السياقة — ترجمة معتمدة (خلال 24 ساعة)' },
    en: { title: 'Driving license translation', short: 'Driving license — sworn translation (24h available)' },
  },
  insuranceRecord: {
    fr: { title: 'Relevé d\'assurance auto', short: 'Relevé d\'information assurance — traduction assermentée' },
    ar: { title: 'كشف التأمين', short: 'كشف معلومات التأمين — ترجمة معتمدة' },
    en: { title: 'Insurance record', short: 'Insurance information record — sworn translation' },
  },
  registration: {
    fr: { title: 'Certificat d\'immatriculation', short: 'Carte grise — traduction assermentée & certifiée' },
    ar: { title: 'شهادة التسجيل', short: 'بطاقة التسجيل — ترجمة معتمدة ومصدقة' },
    en: { title: 'Vehicle registration', short: 'Registration certificate — sworn & certified translation' },
  },
  insuranceAttestation: {
    fr: { title: 'Attestation d\'assurance', short: 'Attestation d\'assurance — traduction assermentée' },
    ar: { title: 'شهادة التأمين', short: 'شهادة التأمين — ترجمة معتمدة' },
    en: { title: 'Insurance certificate', short: 'Insurance certificate — sworn translation' },
  },
  drivingRights: {
    fr: { title: 'Attestation de droits à conduire', short: 'Relevé d\'information restreint — traduction assermentée' },
    ar: { title: 'شهادة حقوق القيادة', short: 'كشف معلومات القيادة — ترجمة معتمدة' },
    en: { title: 'Driving rights attestation', short: 'Restricted driving record — sworn translation' },
  },
  carSale: {
    fr: { title: 'Contrat de vente automobile', short: 'Traduction assermentée contrat de vente voiture' },
    ar: { title: 'عقد بيع السيارة', short: 'ترجمة معتمدة لعقد بيع السيارة' },
    en: { title: 'Car sale contract', short: 'Sworn car sale contract translation' },
  },
  invoice: {
    fr: { title: 'Traduction facture', short: 'STEG, SONEDE, Tunisie Telecom et factures commerciales' },
    ar: { title: 'ترجمة الفاتورة', short: 'ستاغ، الصوناد، اتصالات تونس والفواتير التجارية' },
    en: { title: 'Invoice translation', short: 'STEG, SONEDE, Tunisie Telecom and commercial invoices' },
  },
  bankStatement: {
    fr: { title: 'Relevé de compte', short: 'Relevé bancaire — traduction assermentée' },
    ar: { title: 'كشف حساب بنكي', short: 'كشف حساب — ترجمة معتمدة' },
    en: { title: 'Bank statement', short: 'Bank statement — sworn translation' },
  },
  taxNotice: {
    fr: { title: 'Avis d\'imposition', short: 'Avis d\'imposition — traduction assermentée' },
    ar: { title: 'إشعار الضريبة', short: 'إشعار الضريبة — ترجمة معتمدة' },
    en: { title: 'Tax notice', short: 'Tax assessment notice — sworn translation' },
  },
  payslip: {
    fr: { title: 'Fiche de paie', short: 'Bulletin de salaire — traduction assermentée' },
    ar: { title: 'قسيمة الراتب', short: 'كشف الراتب — ترجمة معتمدة' },
    en: { title: 'Payslip', short: 'Pay slip — sworn translation' },
  },
  employmentAttestation: {
    fr: { title: 'Attestation Pôle emploi', short: 'Traduction attestation — traduction assermentée' },
    ar: { title: 'شهادة التشغيل', short: 'شهادة التشغيل — ترجمة معتمدة' },
    en: { title: 'Employment attestation', short: 'Employment attestation — sworn translation' },
  },
  bankAttestation: {
    fr: { title: 'Attestation bancaire', short: 'Attestation bancaire — traduction assermentée' },
    ar: { title: 'شهادة بنكية', short: 'شهادة بنكية — ترجمة معتمدة' },
    en: { title: 'Bank attestation', short: 'Bank attestation — sworn translation' },
  },
  kbis: {
    fr: { title: 'Extrait Kbis', short: 'Extrait Kbis — traduction assermentée' },
    ar: { title: 'مستخرج السجل التجاري', short: 'مستخرج Kbis — ترجمة معتمدة' },
    en: { title: 'Kbis extract', short: 'Company registry extract — sworn translation' },
  },
  workContract: {
    fr: { title: 'Contrat de travail', short: 'Contrat de travail — traduction assermentée' },
    ar: { title: 'عقد العمل', short: 'عقد العمل — ترجمة معتمدة' },
    en: { title: 'Employment contract', short: 'Employment contract — sworn translation' },
  },
  workCertificate: {
    fr: { title: 'Attestation de travail', short: 'Certificat de travail — traduction assermentée' },
    ar: { title: 'شهادة العمل', short: 'شهادة العمل — ترجمة معتمدة' },
    en: { title: 'Work certificate', short: 'Work certificate — sworn translation' },
  },
  statutes: {
    fr: { title: 'Statuts société', short: 'Statuts — traduction assermentée et certifiée' },
    ar: { title: 'النظام الأساسي', short: 'النظام الأساسي للشركة — ترجمة معتمدة ومصدقة' },
    en: { title: 'Company statutes', short: 'Company statutes — sworn & certified translation' },
  },
  saleAgreement: {
    fr: { title: 'Compromis de vente', short: 'Compromis de vente — traduction assermentée' },
    ar: { title: 'عقد البيع الأولي', short: 'عقد البيع الأولي — ترجمة معتمدة' },
    en: { title: 'Preliminary sale agreement', short: 'Sale agreement — sworn translation' },
  },
  taxAttestation: {
    fr: { title: 'Attestation fiscale', short: 'Attestation fiscale — traduction assermentée & certifiée' },
    ar: { title: 'شهادة ضريبية', short: 'شهادة ضريبية — ترجمة معتمدة ومصدقة' },
    en: { title: 'Tax attestation', short: 'Tax attestation — sworn & certified translation' },
  },
  sirene: {
    fr: { title: 'Avis SIRENE', short: 'Avis de situation au répertoire SIRENE — traduction assermentée' },
    ar: { title: 'إشعار SIRENE', short: 'وضعية السجل التجاري SIRENE — ترجمة معتمدة' },
    en: { title: 'SIRENE notice', short: 'SIRENE registry notice — sworn translation' },
  },
  judgment: {
    fr: { title: 'Traduction jugement', short: 'Jugement — traduction assermentée' },
    ar: { title: 'ترجمة الحكم', short: 'الحكم — ترجمة معتمدة' },
    en: { title: 'Judgment translation', short: 'Court judgment — sworn translation' },
  },
  attestation: {
    fr: { title: 'Traduction attestation', short: 'Attestation officielle — traduction assermentée' },
    ar: { title: 'ترجمة الشهادة', short: 'شهادة رسمية — ترجمة معتمدة' },
    en: { title: 'Attestation translation', short: 'Official attestation — sworn translation' },
  },
  adoptionJudgment: {
    fr: { title: 'Jugement d\'adoption', short: 'Jugement d\'adoption — traduction assermentée' },
    ar: { title: 'حكم التبني', short: 'حكم التبني — ترجمة معتمدة' },
    en: { title: 'Adoption judgment', short: 'Adoption judgment — sworn translation' },
  },
  divorceJudgment: {
    fr: { title: 'Jugement de divorce', short: 'Jugement de divorce — traduction assermentée' },
    ar: { title: 'حكم الطلاق', short: 'حكم الطلاق — ترجمة معتمدة' },
    en: { title: 'Divorce judgment', short: 'Divorce judgment — sworn translation' },
  },
  will: {
    fr: { title: 'Testament', short: 'Testament — traduction assermentée & certifiée' },
    ar: { title: 'الوصية', short: 'الوصية — ترجمة معتمدة ومصدقة' },
    en: { title: 'Will', short: 'Last will — sworn & certified translation' },
  },
  medicalCert: {
    fr: { title: 'Certificat médical', short: 'Certificat médical — traduction assermentée' },
    ar: { title: 'شهادة طبية', short: 'شهادة طبية — ترجمة معتمدة' },
    en: { title: 'Medical certificate', short: 'Medical certificate — sworn translation' },
  },
  vaccination: {
    fr: { title: 'Carnet de vaccination', short: 'Carnet de santé / vaccination — traduction assermentée' },
    ar: { title: 'دفتر التطعيم', short: 'دفتر الصحة / التطعيم — ترجمة معتمدة' },
    en: { title: 'Vaccination record', short: 'Health / vaccination record — sworn translation' },
  },
  apostilleDoc: {
    fr: { title: 'Traduction de l\'apostille', short: 'Apostille — traduction assermentée & certifiée' },
    ar: { title: 'ترجمة الأبوستيل', short: 'الأبوستيل — ترجمة معتمدة ومصدقة' },
    en: { title: 'Apostille translation', short: 'Apostille — sworn & certified translation' },
  },
  extraCopy: {
    fr: { title: 'Exemplaire supplémentaire', short: '+1 exemplaire supplémentaire de la traduction certifiée' },
    ar: { title: 'نسخة إضافية', short: '+1 نسخة إضافية من الترجمة المصدقة' },
    en: { title: 'Extra certified copy', short: '+1 additional certified translation copy' },
  },
  reissue: {
    fr: { title: 'Réédition actualisée', short: 'Réédition actualisée de la traduction assermentée' },
    ar: { title: 'إعادة إصدار محدثة', short: 'إعادة إصدار محدثة للترجمة المعتمدة' },
    en: { title: 'Updated reissue', short: 'Updated reissue of sworn translation' },
  },
  signatureLegalization: {
    fr: { title: 'Légalisation de signature', short: 'Authentification de signature par mairie / notaire' },
    ar: { title: 'تصديق التوقيع', short: 'تصديق التوقيع من البلدية / الموثق' },
    en: { title: 'Signature legalization', short: 'Signature authentication by town hall / notary' },
  },
  commercialTranslation: {
    fr: { title: 'Traduction commerciale', short: 'Contrats, offres, catalogues et documents commerciaux' },
    ar: { title: 'الترجمة التجارية', short: 'العقود والعروض والكتالوجات والوثائق التجارية' },
    en: { title: 'Commercial translation', short: 'Contracts, offers, catalogues and business documents' },
  },
  onlineInterpreter: {
    fr: { title: 'Interprète en ligne pour vos réunions', short: 'Un interprète vous accompagne en direct sur Zoom, Teams ou Meet' },
    ar: { title: 'مترجم فوري لاجتماعاتك عن بُعد', short: 'مترجم يرافقك مباشرة عبر زوم أو تيمز أو ميت' },
    en: { title: 'Online meeting interpreter', short: 'A live interpreter joins you on Zoom, Teams or Meet' },
  },
  academicScientific: {
    fr: { title: 'Traduction académique et scientifique', short: 'Mémoires, thèses, articles et publications scientifiques' },
    ar: { title: 'الترجمة الأكاديمية والعلمية', short: 'البحوث والرسائل الجامعية والمقالات والمنشورات العلمية' },
    en: { title: 'Academic and scientific translation', short: 'Dissertations, theses, articles and scientific publications' },
  },
  marketingAdvertising: {
    fr: { title: 'Traduction marketing et publicitaire', short: 'Campagnes, contenus de marque, brochures et réseaux sociaux' },
    ar: { title: 'ترجمة التسويق والإعلانات', short: 'الحملات ومحتوى العلامة التجارية والمطويات وشبكات التواصل' },
    en: { title: 'Marketing and advertising translation', short: 'Campaigns, branded content, brochures and social media' },
  },
  technicalWebsite: {
    fr: { title: 'Traduction technique et sites internet', short: 'Sites web, logiciels, notices, manuels et fiches techniques' },
    ar: { title: 'الترجمة التقنية وترجمة المواقع', short: 'المواقع والبرمجيات والتعليمات والأدلة والوثائق التقنية' },
    en: { title: 'Technical and website translation', short: 'Websites, software, instructions, manuals and technical sheets' },
  },
  tourismGuide: {
    fr: { title: 'Traduction tourisme et guides', short: 'Guides, circuits, hôtels, menus et contenus touristiques' },
    ar: { title: 'ترجمة السياحة والأدلة', short: 'الأدلة والجولات والفنادق والقوائم والمحتوى السياحي' },
    en: { title: 'Tourism and guide translation', short: 'Guides, tours, hotels, menus and tourism content' },
  },
};

function buildProducts(lang) {
  return Object.fromEntries(
    Object.entries(productKeys).map(([id, copy]) => [id, copy[lang]]),
  );
}

const shared = {
  fr: {
    kicker: 'Traduction assermentée en ligne',
    navTitle: 'Traductions assermentées — catalogue',
    ctaTitle: 'Commandez en ligne simplement et rapidement',
    ctaSubtitle: 'Traduction d\'acte de naissance, d\'acte de mariage et de tous vos documents officiels — commandez la traduction assermentée en 3 clics.',
    ctaButton: 'Commander en ligne',
    featuredTitle: 'Documents les plus commandés',
    featuredSubtitle: 'Traductions assermentées & certifiées — PDF certifié et originaux sur demande',
    from: 'À partir de',
    perPage: 'TND / page',
    perHour: 'TND / heure',
    order: 'Commander',
    backToCatalog: 'Retour au catalogue',
    detailAbout: 'À propos de ce service',
    learnMore: 'Voir le détail',
    seeMore: 'Voir plus',
    orders: 'commandes',
    reviews: 'avis',
    productCount: 'services',
    allCategories: 'Tous',
    typesLabel: 'Types de traduction',
    clearFilter: 'Voir tout',
    searchPlaceholder: 'Rechercher un document (naissance, diplôme, casier…)',
    clearSearch: 'Effacer la recherche',
    sortLabel: 'Trier par',
    sortPopular: 'Les plus demandés',
    sortPriceAsc: 'Prix croissant',
    sortPriceDesc: 'Prix décroissant',
    sortName: 'Nom A → Z',
    noResults: 'Aucun service trouvé',
    noResultsHint: 'Modifiez votre recherche ou réinitialisez les filtres.',
    resetFilters: 'Réinitialiser les filtres',
    categoriesLabel: 'Catégories de services',
    allServicesTitle: 'Nos services de traduction assermentée et certifiée',
    allServicesLead: 'Commandez en ligne simplement et rapidement',
    allServicesOrderCta: 'Commander en ligne',
    categories: {
      civil: 'État civil',
      academic: 'Scolaire & universitaire',
      criminal: 'Casier judiciaire',
      driving: 'Permis & automobile',
      financial: 'Financier & fiscal',
      business: 'Entreprise & travail',
      legalMedical: 'Juridique & médical',
      addons: 'Services complémentaires',
    },
    categoryDesc: {
      civil: 'Actes de naissance, mariage, passeport, carte d\'identité et documents d\'état civil.',
      academic: 'Diplômes, relevés de notes, attestations de scolarité et documents universitaires.',
      criminal: 'Extrait de casier judiciaire et documents de moralité.',
      driving: 'Permis de conduire, carte grise, assurances et documents auto.',
      financial: 'Relevés bancaires, fiches de paie, avis d\'imposition et factures.',
      business: 'Kbis, contrats de travail, statuts et documents d\'entreprise.',
      legalMedical: 'Jugements, attestations, certificats médicaux et apostille.',
      addons: 'Exemplaires supplémentaires, rééditions et légalisation de signature.',
    },
  },
  ar: {
    kicker: 'ترجمة معتمدة عبر الإنترنت',
    navTitle: 'ترجمات معتمدة — الكتالوج',
    ctaTitle: 'اطلب بسهولة وسرعة عبر الإنترنت',
    ctaSubtitle: 'ترجمة شهادة الميلاد وعقد الزواج وجميع وثائقكم الرسمية — اطلبوا الترجمة المعتمدة في 3 نقرات.',
    ctaButton: 'اطلب عبر الإنترنت',
    featuredTitle: 'الوثائق الأكثر طلباً',
    featuredSubtitle: 'ترجمات معتمدة ومصدقة — PDF معتمد ونسخ أصلية عند الطلب',
    from: 'ابتداءً من',
    perPage: 'د.ت / صفحة',
    perHour: 'د.ت / ساعة',
    order: 'اطلب',
    backToCatalog: 'العودة إلى الكتالوج',
    detailAbout: 'عن هذه الخدمة',
    learnMore: 'عرض التفاصيل',
    seeMore: 'عرض المزيد',
    orders: 'طلبات',
    reviews: 'تقييمات',
    productCount: 'خدمات',
    allCategories: 'الكل',
    typesLabel: 'أنواع الترجمة',
    clearFilter: 'عرض الكل',
    searchPlaceholder: 'ابحث عن وثيقة (ميلاد، شهادة، سجل عدلي…)',
    clearSearch: 'مسح البحث',
    sortLabel: 'ترتيب حسب',
    sortPopular: 'الأكثر طلباً',
    sortPriceAsc: 'السعر تصاعدياً',
    sortPriceDesc: 'السعر تنازلياً',
    sortName: 'الاسم أ → ي',
    noResults: 'لم يُعثر على خدمة',
    noResultsHint: 'عدّل البحث أو أعد ضبط الفلاتر.',
    resetFilters: 'إعادة ضبط الفلاتر',
    categoriesLabel: 'فئات الخدمات',
    allServicesTitle: 'خدمات الترجمة المعتمدة والمصدقة',
    allServicesLead: 'اطلب بسهولة وسرعة عبر الإنترنت',
    allServicesOrderCta: 'اطلب عبر الإنترنت',
    categories: {
      civil: 'الحالة المدنية',
      academic: 'الدراسة والجامعة',
      criminal: 'السجل العدلي',
      driving: 'رخصة السياقة والسيارات',
      financial: 'مالي وضريبي',
      business: 'الشركات والعمل',
      legalMedical: 'قانوني وطبي',
      addons: 'خدمات إضافية',
    },
    categoryDesc: {
      civil: 'شهادات الميلاد والزواج وجواز السفر وبطاقة الهوية ووثائق الحالة المدنية.',
      academic: 'الشهادات وكشوف النقاط وشهادات الدراسة والوثائق الجامعية.',
      criminal: 'السجل العدلي ووثائق حسن السيرة.',
      driving: 'رخصة السياقة وبطاقة التسجيل والتأمين ووثائق السيارات.',
      financial: 'كشوف بنكية وقسائم راتب وإشعارات ضريبية وفواتير.',
      business: 'السجل التجاري وعقود العمل والنظام الأساسي ووثائق الشركة.',
      legalMedical: 'الأحكام والشهادات والشهادات الطبية والأبوستيل.',
      addons: 'نسخ إضافية وإعادة إصدار وتصديق التوقيع.',
    },
  },
  en: {
    kicker: 'Sworn translation online',
    navTitle: 'Sworn translations — catalog',
    ctaTitle: 'Order online simply and quickly',
    ctaSubtitle: 'Birth certificate, marriage certificate and all official documents — order sworn translation in 3 clicks.',
    ctaButton: 'Order online',
    featuredTitle: 'Most ordered documents',
    featuredSubtitle: 'Sworn & certified translations — certified PDF and originals on request',
    from: 'From',
    perPage: 'TND / page',
    perHour: 'TND / hour',
    order: 'Order',
    backToCatalog: 'Back to catalog',
    detailAbout: 'About this service',
    learnMore: 'View details',
    seeMore: 'See more',
    orders: 'orders',
    reviews: 'reviews',
    productCount: 'services',
    allCategories: 'All',
    typesLabel: 'Translation types',
    clearFilter: 'View all',
    searchPlaceholder: 'Search a document (birth, diploma, criminal record…)',
    clearSearch: 'Clear search',
    sortLabel: 'Sort by',
    sortPopular: 'Most popular',
    sortPriceAsc: 'Price: low to high',
    sortPriceDesc: 'Price: high to low',
    sortName: 'Name A → Z',
    noResults: 'No services found',
    noResultsHint: 'Try a different search or reset the filters.',
    resetFilters: 'Reset filters',
    categoriesLabel: 'Service categories',
    allServicesTitle: 'Our sworn and certified translation services',
    allServicesLead: 'Order online simply and quickly',
    allServicesOrderCta: 'Order online',
    categories: {
      civil: 'Civil status',
      academic: 'Academic & education',
      criminal: 'Criminal record',
      driving: 'Driving & vehicles',
      financial: 'Financial & tax',
      business: 'Business & employment',
      legalMedical: 'Legal & medical',
      addons: 'Additional services',
    },
    categoryDesc: {
      civil: 'Birth, marriage, passport, ID card and civil status documents.',
      academic: 'Diplomas, transcripts, enrollment certificates and university documents.',
      criminal: 'Criminal record extract and background documents.',
      driving: 'Driving license, registration, insurance and vehicle documents.',
      financial: 'Bank statements, payslips, tax notices and invoices.',
      business: 'Company registry, employment contracts, statutes and business documents.',
      legalMedical: 'Judgments, attestations, medical certificates and apostille.',
      addons: 'Extra copies, reissues and signature legalization.',
    },
  },
};

const detailPageContent = {
  fr: {
    breadcrumbHome: 'Accueil',
    breadcrumbServices: 'Nos services',
    priceRangeLabel: 'Plage de prix',
    priceRangeJoiner: 'à',
    currency: 'TND',
    eurApproxNote: 'Prix indicatifs en euros pour les clients résidant à l\'étranger.',
    hagueNotice:
      'La traduction officielle se fera sur la base du document original. Conformément à la Convention de La Haye du 5 octobre 1961, une apostille pourra être délivrée pour l\'original et pour sa traduction.',
    legalNoticeShort:
      'Traduction sur document original. Apostille disponible (Convention de La Haye, 1961).',
    languages: 'Langue',
    chooseLang: 'Choisissez votre combinaison',
    toward: 'vers',
    apostilleOriginal: 'Apostille doc. original',
    apostilleTranslated: 'Apostille doc. traduit',
    apostillePriceEach: 'par document',
    apostillePriceRange: '10–15 TND / doc.',
    apostilleOfficialNote: 'Tarif fixé par les autorités tunisiennes (montant indicatif pour le devis).',
    langContactHint: 'Vous ne trouvez pas votre combinaison de langues ?',
    langContactAction: 'Contactez-nous',
    yes: 'Oui',
    no: 'Non',
    pages: 'Page(s)',
    perPage: '/ page',
    hours: 'Heure(s)',
    perHour: '/ heure',
    subtotal: 'Sous-total',
    deliveryNote: 'Livraison par e-mail en 48h maximum au format PDF.',
    orderNow: 'Commander en ligne',
    requestQuote: 'Demander un devis',
    share: 'Partager',
    shareCopied: 'Lien copié !',
    similarProducts: 'Produits similaires',
    orderStepsTitle: 'Commander en quelques clics',
    orderSteps: [
      'Choisissez votre traduction',
      'Sélectionnez le nombre de pages',
      'Choisissez la combinaison de langues',
      'Validez votre commande',
    ],
  },
  ar: {
    breadcrumbHome: 'الرئيسية',
    breadcrumbServices: 'خدماتنا',
    priceRangeLabel: 'نطاق السعر',
    priceRangeJoiner: 'إلى',
    currency: 'د.ت',
    eurApproxNote: 'أسعار تقديرية باليورو للعملاء المقيمين في الخارج.',
    hagueNotice:
      'ستتم الترجمة الرسمية على أساس الوثيقة الأصلية. وفقاً لاتفاقية لاهاي بتاريخ 5 أكتوبر 1961، يمكن تسليم أبوستيل للأصل وللترجمة.',
    legalNoticeShort:
      'ترجمة على الوثيقة الأصلية. أبوستيل متاح (اتفاقية لاهاي، 1961).',
    languages: 'اللغة',
    chooseLang: 'اختر تركيبة اللغات',
    toward: 'إلى',
    apostilleOriginal: 'أبوستيل الوثيقة الأصلية',
    apostilleTranslated: 'أبوستيل الوثيقة المترجمة',
    apostillePriceEach: 'لكل وثيقة',
    apostillePriceRange: '10–15 د.ت / وثيقة',
    apostilleOfficialNote: 'التعريفة رسمية وتحددها السلطات التونسية (مبلغ تقديري للعرض).',
    langContactHint: 'لم تجد زوج اللغات المناسب؟',
    langContactAction: 'اتصل بنا',
    yes: 'نعم',
    no: 'لا',
    pages: 'صفحة/صفحات',
    perPage: '/ صفحة',
    hours: 'ساعة/ساعات',
    perHour: '/ ساعة',
    subtotal: 'المجموع الفرعي',
    deliveryNote: 'التسليم عبر البريد الإلكتروني خلال 48 ساعة كحد أقصى بصيغة PDF.',
    orderNow: 'اطلب عبر الإنترنت',
    requestQuote: 'اطلب عرض سعر',
    share: 'مشاركة',
    shareCopied: 'تم نسخ الرابط!',
    similarProducts: 'منتجات مشابهة',
    orderStepsTitle: 'اطلب في بضع نقرات',
    orderSteps: [
      'اختر الترجمة',
      'حدد عدد الصفحات',
      'اختر تركيبة اللغات',
      'أكّد طلبك',
    ],
  },
  en: {
    breadcrumbHome: 'Home',
    breadcrumbServices: 'Our services',
    priceRangeLabel: 'Price range',
    priceRangeJoiner: 'to',
    currency: 'TND',
    eurApproxNote: 'Indicative EUR prices for clients living abroad.',
    hagueNotice:
      'The official translation will be based on the original document. In accordance with the Hague Convention of 5 October 1961, an apostille may be issued for both the original and its translation.',
    legalNoticeShort:
      'Translation based on the original document. Apostille available (Hague Convention, 1961).',
    languages: 'Language',
    chooseLang: 'Choose your language pair',
    toward: 'to',
    apostilleOriginal: 'Apostille — original doc.',
    apostilleTranslated: 'Apostille — translated doc.',
    apostillePriceEach: 'per document',
    apostillePriceRange: '10–15 TND / doc.',
    apostilleOfficialNote: 'Official rate set by Tunisian authorities (indicative amount for quote).',
    langContactHint: 'Can\'t find your language pair?',
    langContactAction: 'Contact us',
    yes: 'Yes',
    no: 'No',
    pages: 'Page(s)',
    perPage: '/ page',
    hours: 'Hour(s)',
    perHour: '/ hour',
    subtotal: 'Subtotal',
    deliveryNote: 'Email delivery within 48 hours max as a PDF.',
    orderNow: 'Order online',
    requestQuote: 'Request a quote',
    share: 'Share',
    shareCopied: 'Link copied!',
    similarProducts: 'Similar products',
    orderStepsTitle: 'Order in a few clicks',
    orderSteps: [
      'Choose your translation',
      'Select the number of pages',
      'Choose the language pair',
      'Confirm your order',
    ],
  },
};

export const serviceCatalogFr = { ...shared.fr, detailPage: detailPageContent.fr, products: buildProducts('fr') };
export const serviceCatalogAr = { ...shared.ar, detailPage: detailPageContent.ar, products: buildProducts('ar') };
export const serviceCatalogEn = { ...shared.en, detailPage: detailPageContent.en, products: buildProducts('en') };
